import { Animated, Image, ImageBackground, Platform, ScrollView, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import React, { useEffect, useState } from 'react'
import GlobalStyles from '../../../globalStyles/globalStyles'
import CoachMarkIconIndex from '../../../assets/StaticImages/InterestImages/CoachMarks/CoachMarkIndex'

const CoachMarkScreen = ({onGotIt}:any) => {
    const [animation] = useState(new Animated.Value(0));
    const [mainAnimation] = useState(new Animated.Value(0));
    const [gotItClicked,setGotItClicked]= useState(false)
    const data =[
        {
            id:0,
            title:"Swipe to show interest instantly.",
            icon:CoachMarkIconIndex.CoachMarkIcon1 ? CoachMarkIconIndex.CoachMarkIcon1: CoachMarkIconIndex.CoachMarkIcon2
        },
        {
            id:1,
            title:"Refine Your Profile for Enhanced Matches",
            icon:CoachMarkIconIndex.CoachMarkIcon2
        },
        {
            id:2,
            title:"Send likes to favorite experiences.",
            icon:CoachMarkIconIndex.CoachMarkIcon3
        },
        {
            id:3,
            title:"Start the Magic: When likes match, conversations begin!",
            icon:CoachMarkIconIndex.CoachMarkIcon4
        },
    ]

    useEffect(() => {
        Animated.timing(mainAnimation, {
        toValue: 1,
        duration: 100,
        useNativeDriver: true,
        }).start();
    }, []);

    useEffect(() => {
        Animated.stagger(100, data.map((_, index) =>
            Animated.timing(animation, {
            toValue: 1,
            duration: 1000,
            useNativeDriver: true,
            delay: index * 100,
            })
        )).start();
        }, []);


    useEffect(() => {
        if(gotItClicked){
            Animated.stagger(100, data.map((_, index) =>
            Animated.timing(animation, {
                toValue: 0.2,
                duration: 1000,
                useNativeDriver: true,
                delay: index * 100,
            })
            )).start();
        }
    }, [gotItClicked]);

  return (
    <Animated.View style={{flex:1,opacity:mainAnimation}}>

    <ImageBackground 
        source={
            require("../../../assets/StaticImages/InterestImages/Interest_date1.png")
        }
        style={{
            // opacity: mainAnimation,
            flex: 1,
            backgroundColor: "#000",
        }}
    >
      <ScrollView contentContainerStyle={styles.container}>
        <View >
          <Text
              style={[
                GlobalStyles.heading2,
                {
                  paddingHorizontal: 16,
                  color:"white"
                },
              ]}
            >
              Interested
            </Text>
            <View 
              style={styles.contentContainer}
            >
                <View style={styles.centerComponent}>
                 {
                    data.map((item: any, index: any) => {
                    return (
                        <Animated.View 
                        key={index} 
                        style={[
                            styles.singleCoachMarkItem,
                            {
                                opacity: animation,
                                transform: [
                                {
                                    translateY: animation.interpolate({
                                    inputRange: [0, 1.2],
                                    outputRange: [-150, 10],
                                    }),
                                },
                                ],
                            }
                            ]}
                        >
                            <Image source={item.icon} alt="" style={styles.singleCoachImg}/>
                          <Text style={[GlobalStyles.heading3,styles.singleCoachMarkTitle]}>{item.title}</Text>
                        </Animated.View>
                    );
                  })
                 }
                </View>
                <View style={styles.lowerButtonComponent}>
                    <TouchableOpacity style={styles.button} onPress={()=>{onGotIt(),setGotItClicked(true)}}>
                        <Text style={styles.buttonText}>GOT IT</Text>
                    </TouchableOpacity>
                </View>
            </View>
        </View>
      </ScrollView>
    </ImageBackground>
    </Animated.View>

  )
}

export default CoachMarkScreen

const styles = StyleSheet.create({
    container:{
      marginTop:20,
      flex:1,
    },
    contentContainer:{
        alignItems: "center",
        height:"100%",
        justifyContent:"center",
        top: Platform.OS==="web" ? 70 : 0
    },
    centerComponent:{
        width:"85%",
    },
    singleCoachMarkItem:{
        display:"flex",
        flexDirection:"row",
        alignItems:"center",
        gap:10,
        margin:10,
        paddingVertical:10,
    },
    singleCoachMarkTitle:{
        color:"white",
        fontSize:20,
        fontWeight:"bold",
        justifyContent:"center",
        width:"80%"
    },
    singleCoachImg:{
        minWidth:55,
        minHeight:55
    },
    lowerButtonComponent:{

    },
    button:{
        borderRadius:10,
        justifyContent:"center",
        alignItems:"center",
        display:"flex",
        flexDirection:"row",
        marginTop:30,
        padding:10,
        paddingHorizontal:20,
        backgroundColor:"white"
    },
    buttonText:{
        fontSize:18,
        fontWeight:"500",
        color:"rgba(192, 164, 111, 1)"
    }
})